import React from "react";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import CastControls from "./CastControls";

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady } = props;
  // Tracked in state (not just the ref) so CastControls mounts once the player is ready.
  const [player, setPlayer] = React.useState(null);

  React.useEffect(() => {
    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
      const videoElement = document.createElement("video-js");

      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      const p = (playerRef.current = videojs(videoElement, options, () => {
        videojs.log("player is ready");
        onReady && onReady(p);
      }));
      setPlayer(p);
    } else {
      // You could update an existing player here on prop change, for example:
      const p = playerRef.current;

      p.autoplay(options.autoplay);
      p.src(options.sources);
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const p = playerRef.current;

    return () => {
      if (p && !p.isDisposed()) {
        p.dispose();
        playerRef.current = null;
        setPlayer(null);
      }
    };
  }, [playerRef]);

  const source = options?.sources?.[0]?.src;

  return (
    // position/size so CastControls can anchor its overlay to the full player area.
    <div data-vjs-player style={{ position: "relative", width: "100%", height: "100%" }}>
      <div ref={videoRef} style={{ width: "100%", height: "100%" }} />
      {player && source && (
        <CastControls
          player={player}
          src={source}
          poster={options?.poster}
          title={options?.castTitle}
          isLive={!!options?.liveui}
        />
      )}
    </div>
  );
};

export default VideoJS;
